module.exports = __webpack_public_path__ + "static/media/rd-center-01.3a25588c.png";